export const UNASSIGNED_EPIC_ID = '0' as const;
